export default "__VITE_ASSET__3a68685f__"